<template>
  <div class="tenant-management-container">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'TenantManagement'
}
</script>

<style lang="scss" scoped>
.tenant-management-container {
  height: 100%;
  width: 100%;
}
</style>